import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
    ArrowDownOutlined,
    ArrowLeftOutlined,
    ArrowUpOutlined,
    CheckCircleOutlined,
    DeleteOutlined,
    EditOutlined,
    ExportOutlined,
    FolderAddOutlined,
    FolderOpenOutlined,
    MailOutlined,
    MergeCellsOutlined,
    MessageOutlined,
    ProfileOutlined,
    SendOutlined
} from "@ant-design/icons";
import {useAuth} from "oidc-react";
import {useJwt} from "react-jwt";
import {
    AutoComplete,
    Button,
    Checkbox,
    Empty,
    Menu,
    Modal,
    notification,
    Select,
    Spin,
    Tag,
    Tooltip
} from "antd";
import EmailAttachmentCard from "../../../components/Card/AttachmentCard/EmailAttachmentCard";
import MoveEmailModal from "../../../components/popups/MoveEmailModal";
import SupplierOptionCard from "../../../components/Options/Supplier";
import SharedService from "../../../services/shared/service";
import SEO from "../../../components/SEO";
import {formatDate} from "../../../utils/datetime.utils";
import {upperCaseFirstLetter} from "../../../utils/string.utils";
import {EmailImportanceColor} from "../../../constants/color.constants";

const icons = {
    "Deleted Items": <DeleteOutlined/>,
    Archive: <FolderAddOutlined/>,
    "Conversation History": <MessageOutlined/>,
    Outbox: <ExportOutlined/>,
    Drafts: <EditOutlined/>,
    Inbox: <MailOutlined/>,
    "Sent Items": <SendOutlined/>,
    "Junk Email": <FolderOpenOutlined/>,
    ForReview: <ProfileOutlined/>,
    Processed: <CheckCircleOutlined/>,
};
let newAttachmentsData = [];
let newPdfData = [];
const EmailQueueDetails = () => {
    const {SubMenu} = Menu;
    const [open, setOpen] = useState(false);
    const [isAssignIconVisible, setAssignIconVisible] = useState(false);
    const [value, setValue] = useState("");
    const [supplierId, setSupplierId] = useState("");
    const [base64Data, setBase64Data] = useState("");
    const [fileName, setFileName] = useState("");
    const [fileType, setFileType] = useState("");
    const [messageContent, setMessageContent] = useState("");
    const [emailQueueData, setEmailQueueData] = useState(null);
    const [emailData, setEmailData] = useState([]);
    const [emailaddress, setEmailaddress] = useState("");
    const [companySearch, setCompanySearch] = useState("");
    const [customerLoading, setCustomerLoading] = useState(false);
    const [supplierOptions, setSupplierOptions] = useState([]);
    // const [mailFolder, setMailFolder] = useState([]);
    const [emailFolder, setEmailFolder] = useState([]);
    const [processedFolder, setProcessedFolder] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [mailFolderMessages, setMailFolderMessages] = useState([]);
    const [messageIdentifier, setMessageIdentifier] = useState("");
    const [loading, setloading] = useState(false);
    const [attachmentLoading, setAttachmentLoading] = useState(false);
    const [assignSupplierPopUp, setAssignSupplierPopUp] = useState(false);
    const [moveloading, setMoveLoading] = useState(false);
    const [receivedDocuments, setReceivedDocuments] = useState([]);
    const [folderName, setFolderName] = useState("");
    const [pdfData, setPdfData] = useState([]);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [supplierSearchText, setSupplierSearchText] = useState("");
    const [supplierLoading, setSupplierLoading] = useState(false);
    const [supplierSearch, setSupplierSearch] = useState("");
    const [selectedVesselId, setSelectedVesselId] = useState(null);
    const [customerType, setCustomerType] = useState(null);
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);
    const [mergeModalOpen, setMergeModalOpen] = useState(false);
    const [mergeLoading, setMergeLoading] = useState(false);
    const [mergeOrder, setMergeOrder] = useState([]);
    const [attachmentMeta, setAttachmentMeta] = useState({});
    const Navigate = useNavigate();
    const location = useLocation();
    const {id} = useParams();
    const {userData} = useAuth();
    const token = userData?.access_token;
    const {decodedToken} = useJwt(token);
    const userEmail = decodedToken?.email;
    const {Option} = Select;
    const pageSEOSettings = {
        title: "Email Detail",
    };
    useEffect(() => {
        fetchEmailQueueById();
    }, [id]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        fetchSupplierOptions();
    }, [supplierSearchText]);

    useEffect(() => {
        if (!id || !token || !attachmentsData?.length) return;
        attachmentsData.forEach((item) => {
            if (item?.Id && !attachmentMeta[item.Id]) {
                fetchAttachmentMeta(item.Id, item.Name);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attachmentsData, id, token]);
    const handleSupplierSearchOptions = (value) => {
        setSupplierSearchText(value);
    };

    const handleArrowClick = () => {
        const currentPageNumber = location?.state?.page || 1;
        Navigate("/emailqueues", {state: {page: currentPageNumber}});
    };

    const fetchSupplierOptions = () => {
        if (supplierSearchText && supplierSearchText.length > 2) {
            setSupplierLoading(true);
            try {
                const data = {
                    searchTerm: supplierSearchText,
                };

                SharedService.post({token, url: "supplier/search/autocomplete", data})
                    .then((response) => {
                        setSupplierOptions(response);
                        setSupplierLoading(false);
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 500) {
                            notification.error({
                                message: "Error",
                                description: error.response.statusText,
                            });
                            setSupplierLoading(true);
                        }
                    });
            } catch (error) {
                if (error.response && error.response.status === 500) {
                    notification.error({
                        message: "Error",
                        description: error.response.statusText,
                    });
                    setSupplierLoading(true);
                }
            }
        } else {
            setSupplierOptions([]);
        }
    };

    const fetchEmailQueueById = async () => {
        setloading(true);

        try {
            const jsonData = await SharedService.get({
                token,
                url: `emailValidationQueue/${id}`,
            });
            if (jsonData) {
                emailFolderReference(jsonData.queueEmail);
                setEmailaddress(jsonData.queueEmail);
                setAttachmentLoading(false);
                if (
                    jsonData &&
                    jsonData.receivedDocuments &&
                    jsonData.receivedDocuments.length <= 0
                ) {
                    setAssignIconVisible(true);
                }

                setEmailData(jsonData);
                setReceivedDocuments(jsonData.receivedDocuments);

                fetchInternetMessageById(jsonData.messageId, jsonData.queueEmail);
                setMessageIdentifier(jsonData.messageId);

                fetchAttachments(jsonData.messageId, jsonData.queueEmail);
            }
        } catch (error) {
            setloading(false);
            setAttachmentLoading(false);
        }
    };

    const fetchAttachments = async (id, email) => {
        setAttachmentLoading(true);
        try {
            const jsonData = await SharedService.get({
                token,
                url: `user/${email}/messages/internetmessage/${id}`,
                params: {$expand: "attachments"},
            });

            if (jsonData && jsonData.Attachments && jsonData.Attachments.filter(a => !a.IsInline)?.length > 0) {
                newPdfData = [];
                newAttachmentsData = [];
                setAttachmentMeta({});

                await Promise.all(
                    jsonData.Attachments
                        .filter(a => !a.IsInline)
                        .map(item =>
                            fetchAttachmentsById(item.Id, jsonData.InternetMessageId, email)
                        )
                );
            }

            setAttachmentLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            if (error.response && error.response.status === 502) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            setAttachmentLoading(false);
        }
    };
    const fetchAttachmentsById = async (id, internetId, email) => {

        try {
            const jsonData = await SharedService.get({
                token,
                url: `user/${email}/messages/internetmessage/${internetId}/attachments/${id}`,
            });

            if (jsonData) {
                newPdfData.push(jsonData.ContentBytes);
                if (!jsonData.IsInline) {
                    newAttachmentsData.push(jsonData);
                    let updatedAttachmentsData = [...newAttachmentsData];
                    setAttachmentsData(updatedAttachmentsData);
                    setPdfData(newPdfData);
                    setAttachmentLoading(false);
                }
                setAttachmentLoading(false);
            }
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            if (error.response && error.response.status === 502) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            setAttachmentLoading(false);
        }
    };
    const fetchAttachmentMeta = async (attachmentId, attachmentName) => {
        try {
            const data = await SharedService.post({
                token,
                url: `emailValidationQueue/${id}/attachment/status`,
                data: {
                    attachmentId,
                    attachmentName,
                },
            });
            if (data) {
                setAttachmentMeta((prev) => ({
                    ...prev,
                    [attachmentId]: {
                        attachmentStatus: data.attachmentStatus ?? data.AttachmentStatus,
                        documentProcessingStatus:
                            data.documentProcessingStatus ?? data.DocumentProcessingStatus,
                        documentId: data.documentId ?? data.DocumentId,
                        comment: data.comment ?? data.Comment,
                        invoiceMatchConfidence:
                            data?.receivedDocument?.invoiceMatchConfidence ?? 0.00,
                    },
                }));
            }
        } catch (error) {
            console.error(`fetchAttachmentMeta(${attachmentId}) failed:`, error?.response?.status, error?.message);
        }
    };

    const emailFolderReference = async (email) => {
        setMoveLoading(true);
        try {
            const responseData = await SharedService.get({
                token,
                url: `user/${email}/mailfolders/ocr/status`,
            });

            const filteredResponse = responseData.filter(
                (item) => item.name === "Inbox" || item.name === "ReviewedIgnore"
            );

            const processedResponse = responseData.find(
                (item) => item.name === "Processed"
            );
            setProcessedFolder(processedResponse);
            setEmailFolder(filteredResponse);
            setMoveLoading(false);
        } catch (error) {
            setMoveLoading(false);
        }
    };
    const moveFolder = async (callback) => {
        setMoveLoading(true);
        try {
            let data = {
                destinationId:
                    (value !== "" && value) ||
                    (processedFolder !== undefined && processedFolder?.folderGuid),
            };

            const response = await SharedService.post({
                token,
                url: `user/${emailaddress}/messages/internetmessage/${messageIdentifier}/move`,
                data,
            });

            // Handle the response data
            if (response) {
                if (
                    folderName !== undefined &&
                    folderName !== null &&
                    folderName !== ""
                ) {
                    if (folderName === "Inbox") {
                        notification.success({
                            message: "Moved successfully to Inbox",
                        });
                        emailValidationQueueStatus();
                    } else {
                        notification.success({
                            message: "Moved successfully to Reviewed Ignore",
                        });
                        emailValidationQueueStatus();
                    }
                } else {
                    emailValidationQueueStatus("processed");
                }
                if (callback) {
                    callback(); // Execute the callback function after moveFolder completes successfully
                }
            }

            setMoveLoading(false);
        } catch (error) {
            setMoveLoading(false);
        }
    };

    const emailStatusColors = {
        forReview: "#ffd900",
        inbox: "#B0C4DE",
        processed: "#5FC66A",
        reviewedIgnore: "#ff8080",
    };

    const emailValidationQueueStatus = async (processed) => {
        try {
            const data = {
                folder: folderName || processed,
            };

            const response = await SharedService.patch({
                token,
                url: `emailValidationQueue/${id}`,
                data,
            });
            if (response) {
                if (!processed) {
                    let currentPageNumber = location?.state?.page || 1;
                    if (folderName === "Inbox") {
                        localStorage.setItem("radioValueemail", "inbox");
                        currentPageNumber = 1;
                        Navigate("/emailqueues", {state: {page: currentPageNumber}});
                    } else if (folderName === "ReviewedIgnore") {
                        localStorage.setItem("radioValueemail", "reviewedIgnore");
                        currentPageNumber = 1;
                        Navigate("/emailqueues", {state: {page: currentPageNumber}});
                    }
                }

                if (processed !== undefined && processed !== null && processed !== "") {
                    notification.success({
                        message: "Moved successfully to Processed",
                    });
                }
            }

            // Handle the response data as per your requirement
            // Close the popup after the API call is completed
        } catch (error) {
            // Handle any errors

            console.error(error);
        }
    };

    const fetchInternetMessageById = async (id, email) => {
        setMessageContent("");

        try {
            const jsonData = await SharedService.get({
                token,
                url: `user/${email}/messages/internetmessage/${id}`,
            });
            setEmailQueueData(jsonData);
            setMessageContent(jsonData?.Body?.Content);
            setloading(false);
        } catch (error) {
            setloading(false);
        }
    };

    const showModal = (email) => {
        emailFolderReference(email);
        setEmailaddress(email);

        setOpen(true);
    };

    const handleOk = (e) => {
        moveFolder();
        setOpen(false);
    };

    const handleCancel = (e) => {
        setOpen(false);
    };

    const createInvoice = async () => {
        setloading(true);

        try {
            const data = {
                base64File: base64Data,
                CustomerType: customerType,
                CustomerId: selectedCustomerId,
                supplierId: supplierId,
                fileName: fileName,
                fileType: fileType,
                sourceId: "3",
                vesselId: selectedVesselId,
                emailValidationQueueId: id,
                uploadedBy: userEmail,
            };

            const response = await SharedService.post({
                token,
                url: "invoice/manual",
                data,
            });
            if (response) {
                moveFolder(() => {
                    Navigate(`/details/${response.id}`);
                    setloading(false);
                });
            }
        } catch (error) {
            setloading(false);
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
        }
    };

    const getDocumentByAttachmentName = (name) => {
        if (receivedDocuments && receivedDocuments.length > 0) {
            return receivedDocuments
                .find((item) => {
                    return (
                        item?.uploadedFileName !== null &&
                        (item.uploadedFileName === name.replace(".pdf", "") ||
                            item.uploadedFileName === name)
                    );
                });
        }
        return null;
    };

    const handleClose = () => {
        setAssignSupplierPopUp(false);
        setSupplierSearch("");
        setCompanySearch("");
    };

    const handleSupplierSelect = (value, option) => {
        const selectedSupplierId = option.id; // Access the ID of the selected suggestion

        setSupplierId(selectedSupplierId);
    };

    const handleSubmit = () => {
        createInvoice();
    };

    const handleCompanySearch = async (value) => {

        setCustomerLoading(true);
        setCompanyOptions([]);
        setCompanySearch(value);
        //if (companyType) {
        // Perform the API call based on the selected companyType
        let payload = {
            searchTerm: value,
        };

        if (value && value.length >= 2) {
            try {
                const response = await SharedService.post({
                    token,
                    url: "customer/search/autocomplete",
                    data: payload,
                });

                let options = response.map((item) => ({
                    label: `${item.displayName}${item?.vesselName ? ` - (${item.vesselName})` : ``}`,
                    value: `${item.displayName}${item?.vesselName ? ` - (${item.vesselName})` : ``}`,
                    VesselId: item.vesselId,
                    id: item.id,
                    VesselName: item?.vesselName,
                    customerName: item.name,
                    CoyId: item.id,
                    AccountingType: item.accountingType,
                    consolidateDetailLines: item.consolidateDetailLines
                }));

                setCompanyOptions(options);
                setCustomerLoading(false);

                // Extract the selected company ID based on the display name
                const selectedCompany = companyOptions.find(
                    (option) => option.value === value
                );
                if (selectedCompany) {
                    if (selectedCompany.AccountingType === "vessel") {
                        // For vessel type, set the selected vessel ID
                        setSelectedCustomerId(selectedCompany?.id);
                        setSelectedVesselId(selectedCompany?.VesselId);
                        setCustomerType(selectedCompany?.accountingType);
                    } else if (selectedCompany.AccountingType === "entity") {
                        setSelectedCustomerId(selectedCompany?.id);
                        setCustomerType(selectedCompany?.AccountingType);
                    }
                }
            } catch (error) {
                if (error.response && error.response.status === 500) {
                    notification.error({
                        message: "Error",
                        description: error.response.statusText,
                    });
                }
            }
        }
        //}
    };

    const openMergeModal = () => {
        setMergeOrder([]);
        setMergeModalOpen(true);
    };

    const closeMergeModal = () => {
        setMergeModalOpen(false);
        setMergeOrder([]);
    };

    const toggleMergeAttachment = (attachmentId) => {
        setMergeOrder((prev) =>
            prev.includes(attachmentId)
                ? prev.filter((x) => x !== attachmentId)
                : [...prev, attachmentId]
        );
    };

    const moveMergeItem = (index, direction) => {
        setMergeOrder((prev) => {
            const next = [...prev];
            const target = index + direction;
            if (target < 0 || target >= next.length) return prev;
            [next[index], next[target]] = [next[target], next[index]];
            return next;
        });
    };

    const mergeAttachments = async () => {
        if (mergeOrder.length === 0) {
            notification.warning({message: "Select at least one attachment to merge."});
            return;
        }
        setMergeLoading(true);
        try {
            const response = await SharedService.post({
                token,
                url: "emailValidationQueue/merge",
                data: {
                    emailValidationQueueId: id,
                    attachments: mergeOrder.map((messageAttachmentId, index) => ({
                        messageAttachmentId,
                        attachmentName: attachmentsData.find((a) => a.Id === messageAttachmentId)?.Name,
                        order: index + 1,
                    })),
                },
            });
            notification.success({message: "Attachments merged successfully."});
            closeMergeModal();
            const newDocumentId = response?.documentId ?? response?.DocumentId;
            if (newDocumentId) {
                Navigate(`/details/${newDocumentId}`);
            }
        } catch (error) {
            notification.error({
                message: "Merge Failed",
                description: error?.response?.data?.message || error?.response?.statusText || "Unable to merge attachments.",
            });
        } finally {
            setMergeLoading(false);
        }
    };

    const handleAssignPopup = (item) => {
        const fileNameWithoutExtension = item.Name.replace(/\.[^/.]+$/, "");

        setAssignSupplierPopUp(true);
        setFileName(fileNameWithoutExtension);
        setFileType(item.ContentType);
        setBase64Data(item.ContentBytes);
    };

    return (
        <div className="h-dvh">
            <SEO {...pageSEOSettings} />
            <MoveEmailModal
                visible={open}
                onClose={handleCancel}
                folders={emailFolder}
                currentFolder={emailData?.folder}
                loading={moveloading}
                title="Move email"
                onMove={(folderGuid, name) => {
                    setValue(folderGuid);
                    setFolderName(name);
                    handleOk();
                }}
            />

            <Modal
                title="Assign Supplier"
                centered={true}
                open={assignSupplierPopUp}
                width={680}
                closable={true}
                onCancel={handleClose}
                footer={[
                    <Button key="cancel" onClick={handleClose} disabled={loading}>Cancel</Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        onClick={handleSubmit}
                        disabled={!supplierId}
                    >
                        Assign &amp; Create Invoice
                    </Button>,
                ]}
            >
                <div className="text-[13px] text-[#7A849A] mb-4">
                    Choose a supplier for this email. Optionally link it to a specific customer.
                </div>

                <div className="flex flex-col gap-4">
                    <div>
                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">
                            Supplier <span style={{color: "#A4231D"}}>*</span>
                        </div>
                        <Select
                            showSearch
                            allowClear
                            placeholder="Search supplier"
                            suffixIcon={null}
                            popupMatchSelectWidth={550}
                            className="w-full"
                            value={supplierSearch || undefined}
                            optionLabelProp="label"
                            defaultActiveFirstOption
                            dropdownStyle={{maxHeight: 600, overflow: "auto"}}
                            notFoundContent={
                                supplierLoading ? (
                                    <Spin className="custom-spin flex justify-center"/>
                                ) : supplierOptions.length === 0 ? (
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                ) : null
                            }
                            onSearch={handleSupplierSearchOptions}
                            onChange={(value) => setSupplierSearch(value)}
                            onSelect={handleSupplierSelect}
                        >
                            {supplierOptions.map((item) => (
                                <Option
                                    key={item.id}
                                    value={item.name}
                                    label={item.name}
                                    id={item.id}
                                    data={item}
                                >
                                    <SupplierOptionCard supplier={item} isSelected={false}/>
                                </Option>
                            ))}
                        </Select>
                    </div>

                    <div>
                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">
                            Customer <span className="font-normal normal-case tracking-normal text-[#A0A8B8]">(optional)</span>
                        </div>
                        <AutoComplete
                            allowClear
                            value={companySearch}
                            onChange={handleCompanySearch}
                            className="w-full"
                            placeholder="Search customer"
                            options={companyOptions.map((result) => ({value: result.value}))}
                            notFoundContent={
                                customerLoading ? (
                                    <Spin className="custom-spin flex justify-center"/>
                                ) : companyOptions.length === 0 ? (
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                ) : null
                            }
                        />
                    </div>
                </div>
            </Modal>

            <Modal
                title="Merge attachments"
                open={mergeModalOpen}
                onCancel={closeMergeModal}
                centered
                closable={false}
                width={640}
                footer={[
                    <Button
                        key="cancel"
                        onClick={closeMergeModal}
                        disabled={mergeLoading}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="merge"
                        type="primary"
                        onClick={mergeAttachments}
                        loading={mergeLoading}
                        disabled={mergeOrder.length === 0}
                    >
                        Merge
                    </Button>,
                ]}
            >
                <Spin spinning={mergeLoading} className="custom-spin" size="large">
                    <div className="text-sm text-gray-600 mb-3">
                        Select attachments to merge. The order in the selected list determines merge order.
                    </div>

                    <div className="mb-4">
                        <div className="text-xs font-semibold text-gray-500 mb-2">AVAILABLE</div>
                        <div className="flex flex-col gap-1 max-h-[220px] overflow-y-auto border rounded p-2">
                            {attachmentsData.map((item) => (
                                <label
                                    key={item.Id}
                                    className="flex items-center gap-2 px-2 py-1 hover:bg-gray-50 cursor-pointer"
                                >
                                    <Checkbox
                                        checked={mergeOrder.includes(item.Id)}
                                        onChange={() => toggleMergeAttachment(item.Id)}
                                    />
                                    <span className="text-sm flex-1 truncate">{item.Name}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div>
                        <div className="text-xs font-semibold text-gray-500 mb-2">
                            MERGE ORDER ({mergeOrder.length} selected)
                        </div>
                        {mergeOrder.length === 0 ? (
                            <div className="text-sm text-gray-400 border rounded p-3 text-center">
                                No attachments selected.
                            </div>
                        ) : (
                            <div className="flex flex-col gap-1 border rounded p-2">
                                {mergeOrder.map((attachmentId, index) => {
                                    const item = attachmentsData.find((a) => a.Id === attachmentId);
                                    if (!item) return null;
                                    return (
                                        <div
                                            key={attachmentId}
                                            className="flex items-center gap-2 px-2 py-1 bg-[#F0F4F6]/50 rounded"
                                        >
                                            <span className="text-xs font-semibold w-6 text-center text-gray-500">
                                                {index + 1}
                                            </span>
                                            <span className="text-sm flex-1 truncate">{item.Name}</span>
                                            <Tooltip title="Move up">
                                                <Button
                                                    size="small"
                                                    type="text"
                                                    icon={<ArrowUpOutlined/>}
                                                    disabled={index === 0}
                                                    onClick={() => moveMergeItem(index, -1)}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Move down">
                                                <Button
                                                    size="small"
                                                    type="text"
                                                    icon={<ArrowDownOutlined/>}
                                                    disabled={index === mergeOrder.length - 1}
                                                    onClick={() => moveMergeItem(index, 1)}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Remove">
                                                <Button
                                                    size="small"
                                                    type="text"
                                                    icon={<DeleteOutlined/>}
                                                    onClick={() => toggleMergeAttachment(attachmentId)}
                                                />
                                            </Tooltip>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </Spin>
            </Modal>

            {/* Page header */}
            <div className="px-4 sm:px-7 py-5">
                <div className="flex items-start gap-4 flex-wrap">
                    <div className="flex-1 min-w-0">
                        <Button
                            size="small"
                            icon={<ArrowLeftOutlined/>}
                            onClick={handleArrowClick}
                            className="mb-2"
                        >
                            All emails
                        </Button>
                        <div className="flex items-center gap-2.5 flex-wrap">
                            <div className="text-[22px] font-semibold text-[#0B1220] leading-tight">
                                Email{emailData?.referenceId ? ` · ${emailData.referenceId}` : ""}
                            </div>
                            {emailData?.folder && (
                                <Tag color={emailStatusColors[emailData.folder]} className="!m-0">
                                    {upperCaseFirstLetter(emailData.folder)}
                                </Tag>
                            )}
                            {emailData?.importance && (
                                <Tag color={EmailImportanceColor[(emailData.importance ?? "normal").toLowerCase()]} className="!m-0">
                                    {upperCaseFirstLetter(emailData.importance)} importance
                                </Tag>
                            )}
                        </div>
                        {emailData?.queueEmail && (
                            <div className="text-[13px] text-[#7A849A] mt-1.5">
                                Received via <span className="text-[#374152]">{emailData.queueEmail}</span>
                                {emailData?.timeStamp && (
                                    <> · {formatDate(emailData.timeStamp, "dd-MMM-yyyy HH:mm")}</>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="flex items-center gap-2">
                        {emailData?.folder !== "inbox" && (
                            <Button
                                icon={<ExportOutlined/>}
                                onClick={() => showModal(emailData.queueEmail)}
                            >
                                Move email
                            </Button>
                        )}
                        {attachmentsData && attachmentsData.length > 1 && (
                            <Button
                                type="primary"
                                icon={<MergeCellsOutlined/>}
                                onClick={openMergeModal}
                            >
                                Merge attachments
                            </Button>
                        )}
                    </div>
                </div>
            </div>

            {/* Main content */}
            <div className="px-4 sm:px-7 pb-7">
                {/* Info card */}
                <div className="bg-white rounded-[14px] border border-[#E4E7EE] p-5 mb-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-x-6 gap-y-4">
                        <div className="min-w-0">
                            <div className="text-[11px] uppercase tracking-wider text-[#7A849A] mb-1">Ref No</div>
                            <div className="text-[14px] font-medium text-[#0B1220] break-all">{emailData?.referenceId || "—"}</div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[11px] uppercase tracking-wider text-[#7A849A] mb-1">Date</div>
                            <div className="text-[14px] font-medium text-[#0B1220] whitespace-nowrap">
                                {emailData?.timeStamp ? formatDate(emailData.timeStamp, "dd-MMM-yyyy HH:mm") : "—"}
                            </div>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[11px] uppercase tracking-wider text-[#7A849A] mb-1">Status</div>
                            <Tag color={emailStatusColors[emailData?.folder]} className="!m-0">
                                {upperCaseFirstLetter(emailData?.folder)}
                            </Tag>
                        </div>
                        <div className="min-w-0 lg:col-span-2">
                            <div className="text-[11px] uppercase tracking-wider text-[#7A849A] mb-1">Queue</div>
                            <Tooltip title={emailData?.queueEmail} placement="topLeft">
                                <div className="text-[14px] font-medium text-[#0B1220] truncate">{emailData?.queueEmail || "—"}</div>
                            </Tooltip>
                        </div>
                        <div className="min-w-0">
                            <div className="text-[11px] uppercase tracking-wider text-[#7A849A] mb-1">Importance</div>
                            <Tag color={EmailImportanceColor[(emailData?.importance ?? "normal").toLowerCase()]} className="!m-0">
                                {upperCaseFirstLetter(emailData?.importance)}
                            </Tag>
                        </div>
                        <div className="min-w-0 sm:col-span-2 lg:col-span-3">
                            <div className="text-[11px] uppercase tracking-wider text-[#7A849A] mb-1">Sender</div>
                            <Tooltip title={emailData?.senderEmail} placement="topLeft">
                                <div className="text-[14px] font-medium text-[#0B1220] truncate">{emailData?.senderEmail || "—"}</div>
                            </Tooltip>
                        </div>
                        <div className="min-w-0 sm:col-span-2 lg:col-span-3">
                            <div className="text-[11px] uppercase tracking-wider text-[#7A849A] mb-1">Subject</div>
                            <div className="text-[14px] font-semibold text-[#0B1220]">{emailData?.subject || "—"}</div>
                        </div>
                        {emailData?.text && (
                            <div className="min-w-0 sm:col-span-2 lg:col-span-6 pt-3 border-t border-[#F1F3F7]">
                                <div className="text-[11px] uppercase tracking-wider text-[#7A849A] mb-1">Validation Message</div>
                                <div className="text-[13px] text-[#374152]">{emailData.text}</div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Body + Attachments */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/* Mail body card */}
                    <div className="bg-white rounded-[14px] border border-[#E4E7EE] flex flex-col overflow-hidden">
                        <div className="px-5 py-3 border-b border-[#F1F3F7]">
                            <div className="text-[15px] font-semibold text-[#0B1220]">Mail body</div>
                        </div>
                        <div className="p-5 max-h-[560px] overflow-y-auto">
                            <Spin size="large" spinning={loading} className="custom-spin">
                                {messageContent ? (
                                    <div className="text-[14px] text-[#1B2332] leading-relaxed" dangerouslySetInnerHTML={{__html: messageContent}}/>
                                ) : (
                                    !loading && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                )}
                            </Spin>
                        </div>
                    </div>

                    {/* Attachments card */}
                    <div className="bg-white rounded-[14px] border border-[#E4E7EE] flex flex-col overflow-hidden">
                        <div className="px-5 py-3 border-b border-[#F1F3F7] flex items-center gap-3">
                            <div className="text-[15px] font-semibold text-[#0B1220]">
                                Attachments
                                {attachmentsData?.length > 0 && (
                                    <span className="text-[#7A849A] font-normal"> · {attachmentsData.length}</span>
                                )}
                            </div>
                        </div>
                        <div className="p-5 max-h-[560px] overflow-y-auto">
                            <Spin size="large" spinning={attachmentLoading} className="custom-spin">
                                {attachmentsData && attachmentsData.length > 0 ? (
                                    <div className="flex flex-col gap-2.5">
                                        {[...attachmentsData].map((item, index) => {
                                            const document = getDocumentByAttachmentName(item.Name);
                                            const filename = document?.referenceId ? `${document.referenceId}-${item.Name}` : item.Name;
                                            const meta = attachmentMeta[item.Id] || {};
                                            return (
                                                <EmailAttachmentCard
                                                    key={index}
                                                    attachment={{
                                                        content: item.ContentBytes,
                                                        fileName: filename,
                                                        size: item.Size,
                                                        type: item.ContentType,
                                                    }}
                                                    documentId={meta.documentId ?? document?.id}
                                                    attachmentStatus={meta.attachmentStatus}
                                                    documentProcessingStatus={meta.documentProcessingStatus}
                                                    comment={meta.comment}
                                                    invoiceMatchConfidence={meta.invoiceMatchConfidence}
                                                    isAssignSupplierVisible={isAssignIconVisible}
                                                    onClickHandleAssignPopup={(event) => handleAssignPopup(item, event)}
                                                />
                                            );
                                        })}
                                    </div>
                                ) : (
                                    !attachmentLoading && <Empty/>
                                )}
                            </Spin>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default EmailQueueDetails;
